module.exports = __webpack_public_path__ + "static/media/Steven-Van_2.22da0a37.jpeg";